export const formatDays = n => {
  if (n == null) return "—";
  return n === 1 ? `${n} ден` : `${n} дни`;
};
